import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.css";

export const XpressPlugLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Extract variant from path: /xpressplug-login-{variant}-mobile
  const pathParts = location.pathname.split("-");
  const variant = pathParts.slice(2, -1).join("-"); // e.g. "corporativo", "adultos", "pixie", "young"

  const handleLogin = () => {
    const currentParams = location.search;
    navigate(`/xpressplug-landing-${variant}-mobile${currentParams}`);
  };

  const handleSignUp = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_tutorial_easy-${variant}-mobile${currentParams}`);
  };

  return (
    <div className="xpl-phone-frame">
      <div className="xpl-phone-screen">
        <div className="xpl-status-bar">
          <div className="xpl-time">11:15</div>
          <div className="xpl-status-icons">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="3" width="3" height="11" rx="1" fill="#333" />
              <rect x="5.5" y="5" width="3" height="9" rx="1" fill="#333" />
              <rect x="10" y="7" width="3" height="7" rx="1" fill="#333" />
              <rect x="14.5" y="9" width="2" height="5" rx="1" fill="#ccc" />
            </svg>
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 11.5C8.82843 11.5 9.5 10.8284 9.5 10C9.5 9.17157 8.82843 8.5 8 8.5C7.17157 8.5 6.5 9.17157 6.5 10C6.5 10.8284 7.17157 11.5 8 11.5Z" fill="#333" />
              <path d="M4.22 7.78C5.22 6.78 6.56 6.18 8 6.18C9.44 6.18 10.78 6.78 11.78 7.78" stroke="#333" strokeWidth="1.2" strokeLinecap="round" />
              <path d="M1.84 5.4C3.5 3.74 5.68 2.82 8 2.82C10.32 2.82 12.5 3.74 14.16 5.4" stroke="#333" strokeWidth="1.2" strokeLinecap="round" />
            </svg>
            <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="3.5" width="7" height="11" rx="1" stroke="#333" />
              <rect x="1.5" y="4.5" width="5" height="9" rx="0.5" fill="#333" />
              <rect x="8.5" y="6" width="1" height="4" rx="0.5" fill="#333" />
            </svg>
          </div>
        </div>

        <div className="xpl-linked-product-bar">
          <span className="xpl-linked-label">Linked product:</span>
          <span className="xpl-linked-id">E0D92DA92358A79A1C6C9614C43B12...</span>
          <button className="xpl-change-btn">Change</button>
        </div>

        <div className="xpl-content">
          <h1 className="xpl-title">Welcome to<br />vBank</h1>
          <p className="xpl-subtitle">Enter your credentials to sign in or access your account.</p>

          <div className="xpl-form">
            <label className="xpl-label">User</label>
            <div className="xpl-input-wrapper">
              <input
                type="text"
                className="xpl-input"
                placeholder="Enter your user"
                readOnly
              />
            </div>

            <label className="xpl-label">Password</label>
            <div className="xpl-input-wrapper">
              <input
                type="password"
                className="xpl-input"
                placeholder="Enter your password"
                readOnly
              />
            </div>
          </div>

          <div className="xpl-buttons">
            <div onClick={handleLogin} className="highlighted-button">
              <button className="xpl-login-btn">Login</button>
            </div>
            <div onClick={handleSignUp} className="highlighted-button">
              <button className="xpl-signup-btn">Sign Up</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
